import React from 'react'

interface HomeWidgetProps {
  /** Small uppercase label rendered in the widget header. */
  title: string
  /** Optional right-aligned action — typically a Link or small button. */
  action?: React.ReactNode
  children?: React.ReactNode
}

/**
 * Uniform shell for the small cards on /home. Each widget owns its
 * own data and self-hides by returning `null` when it has nothing
 * meaningful to show. This shell only provides the visual frame.
 */
export const HomeWidget: React.FC<HomeWidgetProps> = ({
  title,
  action,
  children,
}) => {
  return (
    <div className="rounded-xl bg-surface-raised border border-brd-subtle p-4 sm:p-5">
      <div className="flex items-center justify-between gap-2 mb-3">
        <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-content-tertiary">
          {title}
        </span>
        {action}
      </div>
      {children}
    </div>
  )
}
